import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1 className="about-title">About Tempest Radio</h1>

        <div className="about-content">
          <section className="about-section">
            <h2>What We're About</h2>
            <p>
              Tempest Radio is where good vibes meet great audio. We're not here to revolutionize
              radio (okay, maybe a little), but we are here to make sure you've got quality streams
              when you need them.
            </p>
            <p>
              No algorithm telling you what you should like. No ads interrupting your flow.
              Just pure, unfiltered broadcasting excellence. Well, technically filtered through
              some pretty nice compression codecs, but you get the idea.
            </p>
          </section>

          <section className="about-section">
            <h2>The Tempest Story</h2>
            <p>
              Started in 2025, Tempest Radio emerged from a simple question: "Why isn't there
              a streaming platform that just... works?" So we built one.
            </p>
            <p>
              We're named after the storm, not the Shakespeare play (though we appreciate
              the literary vibes). Like a tempest, we aim to shake things up a bit—but in
              a good way. The kind of storm that clears the air and leaves everything
              feeling fresh.
            </p>
          </section>

          <section className="about-section">
            <h2>Our Philosophy</h2>
            <p>
              Broadcasting should be accessible, quality should be non-negotiable, and nobody
              should have to read a manual to listen to music. We keep things simple, clean,
              and focused on what matters: the audio.
            </p>
            <p>
              We believe in supporting artists, hosts, and creators. We believe in crystal-clear
              sound. And we believe that dark mode should be the default (sorry, not sorry).
            </p>
          </section>

          <section className="about-section">
            <h2>The Tech Stuff (For the Nerds)</h2>
            <p>
              Built with React, powered by AWS, secured with enterprise-grade encryption,
              and obsessively optimized for latency. We use adaptive bitrate streaming,
              CloudFront CDN for global delivery, and enough redundancy to survive a
              literal tempest.
            </p>
            <p>
              But you don't need to know any of that. You just need to know that when you
              hit play, it plays. Every time. Anywhere.
            </p>
          </section>

          <section className="about-section">
            <h2>Join the Storm</h2>
            <p>
              Whether you're here to stream, host, or just vibe, you're part of the Tempest
              Radio community. We're building something different here—something that puts
              listeners and creators first.
            </p>
            <p>
              So grab your headphones, find a stream, and let's broadcast some excellence
              together.
            </p>
          </section>

          <div className="about-footer">
            <p className="about-tagline">
              Tempest Radio — We put the "stream" in "mainstream," then took it back out
              because we're actually indie.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
